import { Machine } from "xstate";

const subscriptionListMachine = Machine({
  id: "subscriptionListMachine",
  initial: "idle",
  states: {
    idle: {
      on: {
        RELOAD: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "idle",
        REJECT: "error",
      },
    },
    error: {
      type: "final",
    },
  },
});

export default subscriptionListMachine;
